import ContractParametersRequest from '@/domain/contract/request/contract-parameters-request';

export default class ProductTemplateRuleRequest {
  ruleId: string;

  parameters: ContractParametersRequest[];

  constructor(obj: any = {}) {
    this.ruleId = obj.id || '';
    this.parameters = ContractParametersRequest.ofList(obj.parameters);
  }

  public static of(obj: any = {}): ProductTemplateRuleRequest {
    return new ProductTemplateRuleRequest(obj || {});
  }

  public static ofList(obj: any[]): ProductTemplateRuleRequest[] {
    return obj.map(this.of);
  }
}
